<template>
  <div id="login" class="login">
    <div class="login-div">
      <div class="left-box">
        <img v-if="imgForm.customLoginBgimg" :src="imgForm.customLoginBgimg" />
        <img v-else :src="imgForm.customLoginBgimg" />
      </div>
      <div class="right-box">
        <div class="logo-box">
          <img :src="imgForm.customLoginLogo" />
          <p>{{imgForm.customLoginTitle}}</p>
        </div>
        <!-- <div class="login_type">
          <span :class="isLogin?'type_active':''" @click="formalLogin('vertifyForm')">密码登录</span>
          <span
            :class="verificationLogin?'type_active':''"
            @click="formalToVertifyLogin('loginForm')"
          >验证码登录</span>
        </div> -->
        <!-- 账号密码登录 -->
        <div key="login" v-if="isLogin">
          <div class="login_type">
            <rs-form
              :show-message="false"
              :model="ruleForm"
              :rules="rules"
              size="small"
              ref="loginForm"
              label-width
              class="login_form"
            >
              <rs-form-item label prop="loginNameOrMobile">
                <rs-input
                  autocomplete="new-password"
                  placeholder="账号/手机号码"
                  v-model.trim="ruleForm.loginNameOrMobile"
                  clearable
                  name="loginNameOrMobile"
                  class="login_input"
                  @keyup.enter.native="submitForm"
                ></rs-input>
              </rs-form-item>
              <rs-form-item label prop="password">
                <rs-input
                  autocomplete="new-password"
                  placeholder="密码"
                  v-model="ruleForm.password"
                  :type="!isView?'password':'text'"
                  class="login_input font_white"
                  @keyup.enter.native="submitForm"
                >
                  <i
                    slot="suffix"
                    :class="isView ? 'rs-input__icon rs-icon-view' : 'eye-img'"
                    @click="isView = !isView"
                  ></i>
                </rs-input>
              </rs-form-item>
              <rs-button
                class="login_button"
                :loading="loading"
                @click="submitForm"
                type="primary"
              >登 录</rs-button>
               <rs-button
                class="login_button"
                @click="bIPLogin"
                type="primary"
                style="margin-left:0"
              >BIP登录</rs-button>
            </rs-form>
          </div>
        </div>
        <!-- 验证码登录 -->
        <div v-if="verificationLogin">
          <rs-form
            :model="vertifyLoginList"
            :rules="vertifyRules"
            ref="vertifyForm"
            label-width
            class="login_form margin-10"
          >
            <rs-form-item label prop="mobileVertify">
              <rs-input
                :class="{border_red:mobileIsHas }"
                placeholder="请输入手机号"
                v-model.trim="vertifyLoginList.mobileVertify"
                clearable
                type="tel"
                class="login_input font-black"
                @keyup.enter.native="vertifyLogin"
                @clear="clear"
                @focus="cleanall"
              ></rs-input>
            </rs-form-item>
            <rs-form-item label prop="CodeVertify">
              <rs-input
                placeholder="验证码"
                v-model="vertifyLoginList.CodeVertify"
                clearable
                type="text"
                class="login_input font-black w59"
                name="vertifyCode"
                @keyup.enter.native="vertifyLogin"
                @focus="cleanall"
              ></rs-input>
              <rs-button
                class="w30 getCount"
                type="text"
                v-if="!vertifyCountdownShow"
                @click="sendSMSCodeVertifyLogin"
              >获取验证码</rs-button>
              <rs-button
                class="w30 getCount"
                type="text"
                v-if="vertifyCountdownShow"
              >{{vertifyCountdownNum2}}秒后重试</rs-button>
            </rs-form-item>
            <!-- <div class="login-another"> -->
            <!-- <el-button class="color-green" type="text" style="float:left;" @click="formalLogin('vertifyForm')">密码登录</el-button> -->
            <!-- </div> -->
            <rs-button
              class="login_button"
              :loading="loading"
              @click="vertifyLogin"
              type="primary"
            >登 录</rs-button>
            
            <!-- <el-button class="login_button login_button_dis" v-if="!verifyFormValid" type="primary">登 录</el-button> -->
          </rs-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "@/api/api";
import Secret from "@/utils/secret";
import Utils from "@/utils/utils";
import Refresh from "@/components/refresh";
import ImgApi from '@/api/imgSetter'
import redirect from '@/webconfig'
export default {
  components: { Refresh },
  data() {
    var loginName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入账号"));
      } else {
        if (this.ruleForm.password !== "") {
          this.$refs.loginForm.validateField("password");
        }
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      htmlP:'',
      isView: false, //密码是否可显示的
      ruleForm: {
        loginNameOrMobile: "",
        password: "",
        companyCode: "10001",
        loginSource: "E_WEB",
        loginType: "PASSWORD"
      },
      loading: false,
      rules: {
        loginNameOrMobile: [{ validator: loginName, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }]
      },
      isLogin: true,
      isForgetPassword: false,
      isViewRes: false,
      isViewResConfirm: false,
      isViewResModify: false,
      isViewResModifyConfirm: false,
      verificationLogin: false,
      vertifyCountdownShow: false,
      vertifyLoginList: {
        mobileVertify: "",
        CodeVertify: "",
        mallCode: ""
      },
      vertifyCountdownNum2: "", //验证码倒计时
      vertifyRules: {
        mobileVertify: [
          //  { validator: validateForgetVertifyLogin, trigger: 'blur' }],
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "手机格式不正确",
            trigger: "blur"
          }
        ],
        CodeVertify: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          {
            pattern: /^\d{0,}$/,
            message: "验证码必须为数字值",
            trigger: "blur"
          }
        ],
        mallCode: [
          { required: true, message: "请输入企业代码", trigger: "blur" }
        ]
      },
        imgForm:{}
    };
  },
  created() {
    top.window.$message = this.$message; // 消息框
  },
  methods: {
    submitForm() {
      let that = this;
      this.$refs["loginForm"].validate(valid => {
        if (!valid) {
          this.$message.warning("请填写登录信息");
          return;
        }
        this.loading = true;
        let form = {
          ...that.ruleForm,
          password: Secret.Encrypt(that.ruleForm.password)
        };
        Api.login(form)
          .then(res => {
            this.loading = false;
            if (res.data.code === 200) {
              let requestData = res.data.data;
              Utils.setSession("userInfo", requestData);
              Utils.setLocalStorage("userInfo", requestData);
              that.$router.push("/home");
            }
          })
          .catch(err => {
            this.loading = false;
          });
      });
    },
    bIPLogin(){
      let url = `${redirect.baseUrl}/idp/oauth2/authorize?client_id=${redirect.clientId}&redirect_uri=${redirect.redirectUri}&response_type=code&state=`
      top.location.href=url
    },
    formalToVertifyLogin(formName) {
      this.isLogin = false;
      this.verificationLogin = true;
      this.resetForm(formName);
    },
    formalLogin(formName) {
      this.isRefreshShow = false;
      this.isLogin = true;
      this.verificationLogin = false;
      this.resetForm(formName);
    },
    resetForm(fromName) {
      this.$refs[fromName].resetFields();
      this.mobileIsHas = false;
      this.mobileIsHasRgis = false;
      this.mobileIsHasForget = false;
      this.mobileIsHasLogin = false;
      this.countdownShow = false;
      this.modifyCountdownShow = false;
      this.vertifyCountdownShow = false;
      this.isView = false;
      this.isViewRes = false;
      this.isViewResConfirm = false;
      this.isViewResModify = false;
      this.isViewResModifyConfirm = false;
      this.isRefreshShowForget = false;
      this.isRefreshShow = false;
      this.isRefreshShowRegis = false;
    },
    clear(val) {
      this.mobileIsHas = false;
      this.mobileIsHasRgis = false;
      this.mobileIsHasForget = false;
      this.mobileIsHasLogin = false;
      console.log("清空的值：", val);
      //忘记密码
      if (this.isForgetPassword) {
        this.modifyCountdownShow = false;
        this.isRefreshShowForget = false;
      }
      //注册
      if (!this.isLogin) {
        this.countdownShow = false;
        this.isRefreshShowRegis = false;
      }
      //验证码登录
      if (this.verificationLogin) {
        this.isRefreshShow = false;
        this.vertifyCountdownShow = false;
      }
    },
    cleanall() {
      this.userError = false;
      this.passwordError = false;
    },
    sendSMSCodeVertifyLogin() {
      if (!this.vertifyLoginList.mobileVertify) {
        this.$message({
          message: "手机号码不能为空!",
          type: "error"
        });
        return false;
      }
      let reMobile = /^1[3456789]\d{9}$/;
      if (!reMobile.test(this.vertifyLoginList.mobileVertify)) {
        console.log("手机格式不正确");
        this.$message({
          message: "手机号码格式错误!",
          type: "error"
        });
        return false;
      }
      if (!this.mobileIsHas) {
        if (this.verificationLogin) {
          // alert(111)
          let params = this.vertifyLoginList.mobileVertify;
          this.vertifyCountdownShow = true;
          this.vertifyCountdownNum = 60;
          this.countdownFunvertical();
          Api.sendVerifyCodeByLogin(params)
            .then(res => {
              if (res.data.code === 200) {
                this.$message({
                  message: "验证码发送成功!",
                  type: "success"
                });
              }
            })
            .catch(() => {});
        }
      }
    },
    vertifyLogin() {
      if (this.mobileIsHas) {
        return;
      }
      this.$refs["vertifyForm"].validate(valid => {
        if (valid) {
          this.login(2);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    countdownFunvertical() {
      // 验证码倒计时
      if (this.vertifyCountdownShow) {
        this.vertifyCountdownNum2 = this.vertifyCountdownNum--;
        if (this.vertifyCountdownNum === -1) {
          this.refreshHiden();
          this.vertifyCountdownShow = false;
          this.vertifyCountdownNum = 60;
          return false;
        }
        this.sleepFunVertical();
      }
    },
    sleepFunVertical() {
      // 延时程序
      setTimeout(() => {
        this.countdownFunvertical();
      }, 1005);
    },
    refreshHiden() {
      this.isRefreshShowRegis = false;
      this.isRefreshShowForget = false;
      this.isRefreshShow = false;
    },
    login(type) {
      let self = this;
      if (!self.loading) {
        self.loading = true;
        let params;
        //type 为1是账号密码登录
        //type 为2是手机验证登录
        params = {
          mobile: self.vertifyLoginList.mobileVertify,
          // 'loginType': "NOPASSWD",
          verifyCode: self.vertifyLoginList.CodeVertify,
          loginSource: "E_MOBILE_CAPTCHA",
          loginType: "NOPASSWD",
          companyCode: "10001"
        };
        Api.login(params)
          .then(res => {
            self.loading = false;
            self.userError = false;
            self.passwordError = false;
            self.isRefreshShow = false;
            if (res.data.code === 200) {
              let userInfo = res.data.data;
              Utils.setSession("userInfo", userInfo);
              Utils.setLocalStorage("userInfo", userInfo);
              self.$router.push("/home");
            }
          })
          .catch(() => {
            self.loading = false;
          });
        // this.$router.push('/');
      }
    },
   
      getImg(){
        ImgApi.findAllConfig({
            configType:'custom',
            pageNum:1,
            pageSize:99
        }).then(res => {
            res.data.data.list.forEach(item => {
                this.imgForm[item.configType] = item.configValue
            })
            console.log(this.imgForm)
            Utils.setSession("imgInfo", this.imgForm);
            Utils.setLocalStorage("imgInfo", this.imgForm);
            this.$forceUpdate()
        })
      }
  },
    mounted(){
      this.getImg()
    }
};
</script>
<style scoped lang="less">
.color-green {
  font-family: PingFangSC-Regular;
  /* font-size: 14px; */
  color: #0091ff !important;
}
.login-another {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 30px;
  height: 40px;
}
.eye-img {
  display: inline-block;
  height: 40px;
  width: 25px;
  text-align: center;
  line-height: 36px;
  background: url("../../assets/images/eye.png") no-repeat;
  background-position: center;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}
.fade-enter, .fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateY(50px);
  opacity: 0;
}
#app {
  width: 100%;
  height: 100%;
}
.title_block {
  width: 100%;
  height: 100px;
  /* background: #fff; */
  display: flex;
  align-items: center;
  font-family: PingFangSC-Medium;
  font-size: 24px;
  color: #444444;
  padding: 0 140px;
}
.title_font {
  border-left: 1px solid #979797;
  display: inline-block;
  height: 35px;
  margin-left: 24px;
  padding-left: 18px;
}
.title {
  font-family: PingFangSC-Regular;
  font-size: 24px;
  color: #666666;
  letter-spacing: 2px;
  text-align: left;
  line-height: 31.46px;
  margin-bottom: 25px;
}
.login {
  width: 100%;
  min-width: 1100px;
  min-height: 620px;
  position: relative;
  height: 100%;
  background: #ffffff;
  overflow: hidden;
}
.login-div {
  width: 950px;
  height: 536px;
  background: #ffffff;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -475px;
  margin-top: -288px;
  border-radius: 6px;
  box-shadow: 1px 1px 14px 0px rgba(131, 165, 234, 0.5);
}
.logo-box {
  width: 100%;
  height: 46px;
  img {
    height: 100%;
    vertical-align: bottom;
    margin-right: 12px;
  }
  p {
    font-family: PingFangSC-Regular;
    font-size: 30px;
    color: #333333;
    display: inline-block;
  }
}
.left-box {
  img {
    border-radius: 6px 0 0 6px;
    width: 474px;
    height: 536px;
    float: left;
  }
}
.right-box {
  width: 474px;
  height: 536px;
  margin-left: 474px;
  padding: 94px 60px 0;
  border-radius: 0 6px 6px 0;
}
.login_type {
  font-family: PingFangSC-Regular;
  font-size: 18px;
  line-height: 28px;
  color: #666666;
  margin: 34px 0;
}
.login_type span:first-child {
  cursor: pointer;
  padding-right: 6px;
  position: relative;
}
.login_type span:first-child:after {
  content: "";
  width: 1px;
  height: 16px;
  position: absolute;
  background: #d3d3d3;
  right: 0;
  top: 5px;
}
.login_type span:last-child {
  cursor: pointer;
  padding-left: 6px;
}
.type_active {
  color: #0091ff;
}
.logo_block {
  width: 185px;
  height: 40px;
  background: url("../../assets/images/sasslogo.png") no-repeat;
  background-size: 100% 100%;
  display: inline-block;
}
.login_form .forgetPw {
  display: block;
}
.login_form {
  width: 100%;
}
/deep/ .login_form .rs-form-item .rs-form-item__content {
  height: 36px;
  line-height: 36px;
}
.login_input input {
  border: 0;
  background: #f5f5f5 !important;
  border-radius: 4px;
  color: #666;
}
.login_input input:focus {
  border-color: #1151d1 !important;
}
.rs-form-item {
  margin-bottom: 0;
}
.login_button {
  width: 100%;
  height: 36px;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #ffffff;
  margin-top: 28px;
  background: #3e62ad;
  box-shadow: 0 1px 2px 0 rgba(69, 69, 69, 0.5);
  border-radius: 4px;
  border-radius: 4px;
}
.login_button_dis {
  width: 100%;
  height: 36px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.1);
  border: 0;
}
.w70 {
  width: 70%;
}
.w59 {
  width: 66%;
}
.w30 {
  width: 31%;
}
.font-black {
  color: rgba(0, 0, 0, 0.5);
}
.getCount {
  height: 36px;
  background: #ffffff;
  border: 1px solid #ededed;
  margin-left: 3%;
  padding: 10px 20px;
  border-radius: 4px;
  text-align: center;
  color: rgba(0, 0, 0, 0.5) !important;
  letter-spacing: 0.17px;
}
/deep/.rs-form-item:after,
.rs-form-item:before {
  display: initial !important;
}
.right-info {
  width: 100%;
  position: absolute;
  bottom: 20px;
  text-align: center;
  color: #999999;
  a {
    color: #66bdff;
  }
  a:hover {
    color: #0091ea;
  }
}
</style>
<style>
.login_form .rs-input__inner {
  height: 36px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.7);
}
.login_form .rs-form-item {
  margin-top: 18px;
}
.login_button .rs-button {
  border-radius: 0;
}
.rs-input__icon {
  transition: none;
}
/* chrom提示框 */
.chroms-tips-main {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 6vh;
}
</style>